Namespace 'Customer.Ticket'

class Customer.Ticket.SurveyNoticeView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/body/survey_notice']
  className: 'survey-notice'

  initialize: ({datetime}) ->
    @datetime = datetime

  render: ->
    @$el.html @template
      datetime: @datetime
    @
